// eslint-disable-next-line import/no-anonymous-default-export
export default {
  toolsTitle: 'HitPaw Online الطبعة النهائية',
  fileSizeLimitTitle: 'لا يمكن أن تتجاوز أحجام الملفات للحسابات المجانية 20MB.',
  freeTimesLimitTitle: 'انتهت النسخة التجريبية المجانية للحساب اليوم.',
  freeImgCutoutTimesLimitTitle:
    'نفذت فرصة اليوم لإزالة خلفية الصورة، يرجى الترقية إلى الحساب المميز للوصول إلى جميع المزايا المدفوعة',
  total: 'الإجمالي',
  enterCode: 'أدخل الرمز',
  signUpToPurchaseBtn: 'أنشئ حسابًا للشراء',
  goPurchseBtn: 'اذهب إلى الشراء',
  saveTips: 'وفر حتى {{num}}%',
  discount: 'خصم',
  priceWeek: '$9.99',
  priceMonth: '$7.49',
  priceYear: '$3.75',
  billedMonth: '29.99 دولارًا شهريًا',
  billedYear: '179.99 دولارًا سنويًا',
  weekly: 'أسبوعي',
  monthly: 'سنويًا',
  yearly: 'شهريًا',
  week: 'أسبوع',
  AlreadySubscribe: 'مشترك بالفعل؟',
  vipTips1: 'لا يوجد حد لحجم الملف',
  vipTips2: 'عدد غير محدود من الملفات التي تمت معالجتها',
  vipTips3: 'تغيير غير محدود لخلفية الصورة',
  vipTips4: 'استخدم جميع الأدوات المجانية والميزات المتميزة',
  purchaseTips: 'التجديد تلقائيًا والإلغاء في أي وقت.',
  tips: 'نصائح:',
  promoCodeInvalidTips: 'رمزك الترويجي غير صالح',
  //2022.09.28 xxy
  freeImgBgChangerTimesLimitTitle:
    'Today’s trial oppotunity for changing background has been run out, please upgrade to Pro to access all premium features',
  vipBgChangerTips: 'Change image backgrounds without limits',
};
